import React, { Component } from 'react';
import { Container } from 'flux/utils';
import { dispatch } from '../../dispatcher/Dispatcher';

import { getItem as getLang } from '../../common/lang';

import Header from '../../components/Header/Header.jsx';
import PullLoader from '../../components/PullLoader/PullLoader.jsx';
import RecordList from '../../components/RecordList/RecordList.jsx';
import FormControl from '../../components/FormControl/FormControl.jsx';
import TextInput from '../../components/TextInput/TextInput.jsx';
import Button from '../../components/Button/Button.jsx';
import Form from '../../components/Form/Form.jsx';
import Loader from '../../components/Loader/Loader.jsx';
import PageOpener from '../../components/PageOpener/PageOpener.jsx';

import RepairClockInStore from '../../stores/RepairClockInStore';
import RepairClockInDataUtils from '../../data-utils/RepairClockInDataUtils';

class RepairClockInViewList extends Component {
    static getStores() {
		return [RepairClockInStore];
	}

	static calculateState() {
		return RepairClockInStore.getState();
	}
	constructor(props){
		super(props);
        var periodId = this.props.routeParams.id;
        //console.log(periodId);
		RepairClockInDataUtils.getEmpRciExList(periodId);
        RepairClockInDataUtils.getEmpRciPeriodList();
	}

    render(){
		const{
			selectTable,
			rciList = [],
            periodList = [],
			submitting = false,
			status = 'loading'
		} = this.state;
        
		//console.log(rciList);

        return (<div>
				<Header
					back
					title={getLang('RCI_VIEW_DATA')}
				/>
				<PullLoader ref="pullLoader" status={status} ></PullLoader>
				<ul className={'record-list' + (selectTable ? ' record-list-selectable' : '')}>
					{
						rciList.map((item, index) => {
							return(
								<li>
									<a href={'#/my-rci/viewrecord/'+item.att_exe_id} className='record-item'>
										<span className='record-item-name'>{item.att_exe_typname} - {item.att_exe_resdesc}</span>
										<span className='record-item-time'>{item.att_exe_ctime}</span>
										<span className={'record-item-status'}>{item.att_exe_gtime}</span>
									</a>
								</li>
							);
						})
					}
				</ul>
				<Button icon='search' action onClick={::this.openSearchDialog} />
                <PageOpener ref='openSearch'>
					<Loader status={status}>
						<ul className={'record-list' + (selectTable ? ' record-list-selectable' : '')}>
                        {
                            periodList.map((item, index) => {
                                return(
                                    <li>
                                        <a href='javascript:;' className='record-item' onClick={this.closeSearchDialog.bind(this, item.pla_per_id)}>
                                            <span className='record-item-name'>{item.pla_per_code}</span>
                                            <span className='record-item-hours record-choose' >选择</span>
                                        </a>
                                    </li>
                                );
                            })
                        }
                    </ul>
					</Loader>
				</PageOpener>
				</div>);
    }

    /**
     * 打开筛选对话框
     * 
     */
    openSearchDialog(e){
        this.refs.openSearch.open(e);
        this.refs.pullLoader.stopLoading();
    }
    /**
     * 关闭及渲染当前页
     * 
     */
    closeSearchDialog(pid, e){
        this.refs.openSearch.close(e);
        this.refs.pullLoader.stopLoading();
        RepairClockInDataUtils.getEmpRciExList(pid);
        RepairClockInDataUtils.getEmpRciPeriodList();
    }
}

export default Container.create(RepairClockInViewList);


// WEBPACK FOOTER //
// ./src/containers/RepairClockIn/RepairClockInEmpViewListContainer.js